import { Component, OnInit } from '@angular/core';
import { FeedbackService, MsgType } from 'src/app/_provider/feedback.service';
import { BoardUserSelectComponent } from '../board-user-select/board-user-select.component';
import { Employee } from 'src/app/_interfaces/Employee';
import { BoardEdiorviewerSelectComponent } from '../board-ediorviewer-select/board-ediorviewer-select.component';
import { BoardCardView, BoardCardViewEditorComponent } from '../board-card-view-editor/board-card-view-editor.component';
import { ModalController } from '@ionic/angular';
import { BoardStatusViewSelect, BoardStatusViewSelectComponent } from '../board-status-view-select/board-status-view-select.component';
import { TicketEditService } from 'src/app/_provider/ticket-edit.service';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { BoardTemplate, BoardTemplateService } from 'src/app/_provider/boards/board-template.service';
import { TicketTag, BoardEditorFilter, BoardService } from 'src/app/_provider/boards/board.service';
import { AuthService } from 'src/app/_provider/auth.service';
import { TagOverviewPage } from '../../new-settings/ticket-settings/tag-overview/tag-overview.page';

@Component({
  selector: 'app-board-template-edit',
  templateUrl: './board-template-edit.page.html',
  styleUrls: ['./board-template-edit.page.scss'],
})
export class BoardTemplateEditPage implements OnInit {

  public isNew: boolean = true
  private originalBase64Strings: any = {
    base: "",
    tags: "",
    employees: "",
    boardStatusViewSelect: "",
    boardCardView: ""
  }

  public icons: string[] = [
    "fa-hammer", "fa-comment", "fa-credit-card", "fa-cube", "fa-database", "fa-desktop", "fa-dollar-sign", "fa-exclamation", "fa-gear", "fa-globe", "fa-ufo", "fa-graph-bar", "fa-house", "fa-information", "fa-message", "fa-ticket", "fa-timer", "fa-user-business"
  ]

  public availabeleTags: TicketTag[] = []

  public template: BoardTemplate = {
    id: 0,
    name: "",
    icon: "fa-hammer",
    colored: false,
    editorFilter: BoardEditorFilter.ALL,
    boardStatusViewSelect: [],
    employees: [],
    tags: [],
    boardCardView: []
  }

  public get title(): string{
    return !this.template.name ? "Neues Board" : this.template.name
  }

  public get cardViewAnyActive(): boolean{
    return this.template.boardCardView.some(v => !v.active)
  }

  public get statusViewInactiveLength(): number{
    return this.template.boardStatusViewSelect.filter(v => !v.active).length
  }
  
  public get cardViewInactiveLength(): number{
    return this.template.boardCardView.filter(v => !v.active).length
  }


  constructor(
    public boardSrv: BoardService,
    private modalCtrl: ModalController,
    private ticketEditSrv: TicketEditService,
    private authSrv: AuthService,
    private feedback: FeedbackService,
    public boardTemplateSrv: BoardTemplateService
  ) { 
    
    
  }
  ngOnInit() {
    this.availabeleTags = JSON.parse(JSON.stringify(this.boardSrv.tags))
    this.template.boardCardView = JSON.parse(JSON.stringify( this.boardSrv.boardView))
    if(this.isNew) { 
      this.template.boardStatusViewSelect = this.ticketEditSrv.ticketStates.map(ts => ({id: ts.id, name: ts.description, active: true}))
      this.availabeleTags.forEach(tag => tag.checked = false)
      this.template.boardCardView.forEach(view => view.active = true)
      this.template.employees = JSON.parse(JSON.stringify(this.ticketEditSrv.employees.filter(e => e.id == this.authSrv.getUser()?.id)))
    }else{
      this.originalBase64Strings.base = this.getTemplateBase64(this.template)
      this.originalBase64Strings.tags = btoa(JSON.stringify(this.template.tags))
      this.originalBase64Strings.boardStatusViewSelect = btoa(JSON.stringify(this.template.boardStatusViewSelect))
      this.originalBase64Strings.boardCardView = btoa(JSON.stringify(this.template.boardCardView))
      if(this.template.employees.length == 0) this.template.employees = JSON.parse(JSON.stringify(this.ticketEditSrv.employees.map(e => ({...e, checked: true}))))
      
      this.originalBase64Strings.employees = btoa(JSON.stringify(this.template.employees))
    }
  }

  private getTemplateBase64(template: BoardTemplate){
    return btoa(JSON.stringify([template.name, template.icon, template.colored, template.public, template.editorFilter]))  
  }


  public async openUserSelect(event: any){
    const employeeList: Employee[] = JSON.parse(JSON.stringify(this.boardSrv.employees.map(e => ({...e, checked: this.template.employees.find(e2 => e2.id == e.id)}))))
    
    await this.feedback.openPopover(BoardUserSelectComponent, event, {
      employees: employeeList,
      newEmployeesSelected: (data: Employee[])=>this.template.employees = data
    })
  }

  
  public async openEditorFilter(event: any){
    await this.feedback.openPopover(BoardEdiorviewerSelectComponent, event, {
      editorFilter: this.template.editorFilter,
      newEditorFilterSelected: (data: BoardEditorFilter)=>{
      this.template.editorFilter = data
    }})
  }

  public async openCardViewEditor(event: any){
    await this.feedback.openPopover(BoardCardViewEditorComponent, event, {
      cardView: this.template.boardCardView,
      viewChanged: (data: BoardCardView[]) =>{
        this.template.boardCardView = data
      }
    })
  }

  public async openStatusView(event: any){
    
    await this.feedback.openPopover(BoardStatusViewSelectComponent, event, {
      statusViewItems: this.template.boardStatusViewSelect,
      viewChanged: (data: BoardStatusViewSelect[])=>this.template.boardStatusViewSelect = data
    })
  }

  public async close(){
    await this.modalCtrl.dismiss()
  }

  public async save(){
    if(this.authSrv.isDemoMode) {
      await this.feedback.showMsg(MsgType.Info, "Leider können im Demo-Modus keine Templates erstellt oder bearbeitet werden.🥸")
      return
    }

    if(!this.template.name) return await this.feedback.showError("Bitte geben Sie erst einen Namen für das Board an.")
    if(this.template.employees.length == 0) return await this.feedback.showError("Bitte wählen Sie mindestens einen Mitarbeiter aus.")
    this.template.tags = this.availabeleTags.filter(t => t.checked).map(t => ({id: t.id, description: t.description, color: t.color}))

    
    if(this.isNew) {
      const template: BoardTemplate = JSON.parse(JSON.stringify(this.template))
      if(this.template.employees.length == this.ticketEditSrv.employees.length) template.employees = []
      await this.feedback.showLoading(async () => await this.boardTemplateSrv.createNewTemplate(template), "Neues Board wird erstellt...") 
    }
    else{

      let saveActions: Promise<HttpFunctionResult<any>>[] = []

      if(this.originalBase64Strings.base != this.getTemplateBase64(this.template))
        saveActions.push(this.boardTemplateSrv.updateBoardFilterBase(this.template))
      
      if(this.originalBase64Strings.tags != btoa(JSON.stringify(this.template.tags)))
        saveActions.push(this.boardTemplateSrv.updateBoardFilterTags(this.template.tags, this.template.id))
      
      if(this.originalBase64Strings.employees != btoa(JSON.stringify(this.template.employees))){
        const employees: Employee[] = this.template.employees.length == this.ticketEditSrv.employees.length ? [] : this.template.employees
        saveActions.push(this.boardTemplateSrv.updateBoardFilterEmployees(employees, this.template.id))
      }
      
      if(this.originalBase64Strings.boardStatusViewSelect != btoa(JSON.stringify(this.template.boardStatusViewSelect)))
        saveActions.push(this.boardTemplateSrv.updateBoardFilterStatusViewSelect(this.template.boardStatusViewSelect, this.template.id))

      if(this.originalBase64Strings.boardCardView != btoa(JSON.stringify(this.template.boardCardView)))
        saveActions.push(this.boardTemplateSrv.updateBoardFilterCardView(this.template.boardCardView, this.template.id))

      if(saveActions.length > 0){
        await this.feedback.updateLoading("Speichern...")
        const result: HttpFunctionResult<any>[] = await Promise.all(saveActions)
        await this.feedback.hideLoading()
        if(result.some(r => !r.success)) return
        if(this.boardTemplateSrv?.reloadBoard) this.boardTemplateSrv.reloadBoard()
      }
    }
    

    await this.close()
  }

  public async showTagOverview(){
    await this.feedback.showModal({
      component: TagOverviewPage
    })

    this.availabeleTags = JSON.parse(JSON.stringify(this.boardSrv.tags))
  }

}
